import { cn } from '@zep-us/zus/utils';
interface ErrorMessageProps {
  message: string;
  className?: string;
}

/**
 * 에러 메시지 표시 컴포넌트
 *
 * 일관된 에러 메시지 스타일링을 제공합니다.
 * 사용 시 조건부 렌더링으로 명시적으로 표시 여부를 결정하세요.
 *
 * @example
 * {error && <ErrorMessage message={error} className="mt-1" />}
 * {error && <ErrorMessage message={error} className="mt-1 text-center" />}
 */
export function ErrorMessage({
  message,
  className
}: ErrorMessageProps) {
  return <p className={cn('text-caption-md-medium text-destructive', className)} data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.tsx">
      {message}
    </p>;
}